"use strict";

export default class DirectDrMemberAuthorsController {
  /*@ngInject*/
  constructor(ElasticAPI, LanguageService, $window) {
    this.ElasticAPI = ElasticAPI;
    this.ls = LanguageService;
    this.$window = $window;
    this.results = [];
    this.enabled = false;
    this._query = null;
    this.query = "";
  }

  changeLanguage(lang) {
    this.ls.set(lang);
    this.$window.location.reload();
  }

  buildResultLabel(detail) {
    let label = `${detail.firstname || ""} ${detail.lastname || ""} ${
      detail.birth_year || detail.decease_year ? "(" : ""
    }${detail.birth_year || " "}${
      detail.decease_year ? ` - ${detail.decease_year}` : ""
    }${detail.birth_year || detail.decease_year ? ")" : ""}`;
    return label.trim();
  }

  searchKeyDown($event) {
    if ($event.keyCode === 13 && this.query && this.query.length > 1) {
      this.searchDirectDrMemberAuthors();
    }
  }

  searchDirectDrMemberAuthors() {
    this.results = null;
    this.enabled = false;
    this._query = this.query;
    let that = this;
    if (!(this.query && this.query.length > 1)) {
      return;
    }
    return this.ElasticAPI.searchDirectDrMemberAuthors(
      { name: this.query },
      function (results) {
        return results;
      }
    ).$promise.then(function (results) {
      results = JSON.parse(JSON.stringify(results));
      for (var r in results) {
        let detail = results[r].detail;
        results[r].label = that.buildResultLabel(detail);
        results[r].copyright = detail.copyright;
      }
      that.results = results;
      that.enabled = true;
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/direct-dr-member-authors/direct-dr-member-authors.controller.js